import { render, staticRenderFns } from "./PowerCharges.vue?vue&type=template&id=2c6fb1b7&"
import script from "./PowerCharges.vue?vue&type=script&lang=js&"
export * from "./PowerCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports